import { useQuery } from '@tanstack/react-query';

import { DispensariesApi } from 'api';
import { MAX_DEPOSIT_KEY } from 'tanstack-hooks/keys';

export function useMaxDeposit(dispensaryId: string) {
  const dispensariesApi = new DispensariesApi();

  const { data: maxDeposit, isLoading: isLoadingMaxDeposit } = useQuery({
    enabled: !!dispensaryId.length,
    queryKey: [MAX_DEPOSIT_KEY, dispensaryId],
    queryFn: () => dispensariesApi.getMaxDeposit(dispensaryId)
  });

  return { maxDeposit, isLoadingMaxDeposit };
}
